import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { FilterObject } from '../filter-object';

@Component({
  selector: 'filter-not-true-boolean',
  templateUrl: './filter-not-true-boolean.component.html',
  styleUrls: ['./filter-not-true-boolean.component.scss'],
})
export class FilterNotTrueBooleanComponent implements OnInit {
  @Input()
  public filterObject: FilterObject;

  @Output()
  public toggleFilterEmitter: EventEmitter<string> = new EventEmitter<string>();

  filterChecked: boolean;

  ngOnInit(): void {
    if (this.filterObject != null) {
      this.filterObject.value = 'true';
      this.filterChecked =
        this.filterObject.active == null ? false : this.filterObject.active;
    } else {
      this.filterChecked = false;
    }
  }

  public handleToggle(event: MatCheckboxChange): void {
    this.toggleFilterEmitter.emit(this.filterObject.key);
  }
}
